import axios from "axios"

/**
 * Fetch + normalize the gameboard payload.
 * Scales coordinates from recording space to design space.
 */

// Scale factor: design width / recording screen width
const SCALE = 2.7

// Offsets as fraction of board dimensions
// Positive = move right/down, Negative = move left/up
const X_OFFSET_PCT = 0.01   // try 0.02 to move right, -0.02 to move left
const Y_OFFSET_PCT = 0

export async function fetchGameboard() {
  const { data } = await axios.get(`/gameboard/v2`)

  const root = data?.data ?? data ?? {}
  const gb = root.game_board || root.gameBoard || root.board || {}

  const width  = Number(gb.width)  || 1080
  const height = Number(gb.height) || 1920

  const backgroundUrl =
    gb.background?.url ||
    (gb.game_board_file_path && gb.game_board_file_name
      ? gb.game_board_file_path + gb.game_board_file_name
      : "")

  // pick nodes
  let rawNodes = Array.isArray(gb.nodes) ? gb.nodes : []
  if (!rawNodes.length && Array.isArray(gb.steps))       rawNodes = gb.steps
  if (!rawNodes.length && Array.isArray(gb.path?.nodes)) rawNodes = gb.path.nodes

  // sanitize → numeric
  let nodes = (rawNodes || [])
    .map((n, i) => ({
      index: Number(n.index ?? i),
      x: Number(n.x ?? n.x_position),
      y: Number(n.y ?? n.y_position),
      type: n.type || n.step_type || "NORMAL",
      elements: Array.isArray(n.elements) ? n.elements : []
    }))
    .filter(n => Number.isFinite(n.x) && Number.isFinite(n.y))

  if (nodes.length) {
    const xs = nodes.map(n => n.x), ys = nodes.map(n => n.y)
    const maxX = Math.max(...xs)
    const maxY = Math.max(...ys)

    // Check if coordinates already span most of the design canvas
    const alreadyFullScale = maxX > width * 0.5 && maxY > height * 0.5

    if (alreadyFullScale) {
      // eslint-disable-next-line no-console
      console.log("[GB svc] coords already full scale, no transformation")
    } else {
      const xOffset = width * X_OFFSET_PCT
      const yOffset = height * Y_OFFSET_PCT

      nodes = nodes.map(n => ({
        ...n,
        x: n.x * SCALE + xOffset,
        y: n.y * SCALE + yOffset
      }))

      // eslint-disable-next-line no-console
      console.log("[GB svc] scaled from origin", { 
        SCALE,
        xOffset: Math.round(xOffset),
        yOffset: Math.round(yOffset)
      })
    }
  }

  const pointsPerStep =
    Number(gb.pointsPerStep) ||
    Number(gb.points_per_step) ||
    100

  const teams =
    (Array.isArray(root.teams) && root.teams) ||
    (Array.isArray(root.team)  && root.team)  ||
    []

  return {
    gameBoard: {
      width,
      height,
      background: backgroundUrl ? { url: backgroundUrl } : {},
      nodes,
      pointsPerStep
    },
    teams
  }
}

export async function fetchTeamPace() {
  const { data } = await axios.get('/gameboard/teampace')
  const p = (data && data.data) ? data.data : (data || {})
  const text = p.team_pace_text || ''
  const imageUrl = (p.file_path && p.file_name) ? (p.file_path + p.file_name) : ''
  return { text, imageUrl }
}